import { Attachment, FileIsFor, Investigation } from '../../../models';
import { EntityAction, InvestigationAttachmentService } from '../../../services';
import { HasAttachments } from '../attachments';

class HasInvestigationAttachments extends HasAttachments<Investigation> {
  protected photosAreFor: FileIsFor = FileIsFor.INVESTIGATION;
  protected titleStringKey: string = 'attachment.investigationAttachments';
  protected emptyStateStringKey: string | null = 'attachment.noInvestigation';

  protected getForDownload(id: number): Promise<any> {
    return InvestigationAttachmentService.getForDownload(id);
  }

  protected uploadAttachment(isPrivate: boolean, formData: FormData): Promise<any> {
    return InvestigationAttachmentService.upload(this.attachmentUploadTargetId, isPrivate, formData);
  }

  protected setPrivate(attachment: Attachment): Promise<any> {
    return InvestigationAttachmentService.setPrivate(attachment.id, !attachment.private);
  }

  protected attachmentsChanged(action: EntityAction, attachment: Attachment): void {
    InvestigationAttachmentService.attachmentChanged(action, attachment);
  }
}

export default HasInvestigationAttachments;
